require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-machine-learning-project-model-v-1.json") })
        }
      }, "path---posts-machine-learning-project-model-v-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-machine-learning-project-model-v-1!./.cache/json/posts-machine-learning-project-model-v-1.json
// module id = 393
// module chunks = 231608221292675